/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_accounts_polygon_create_drawer_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Se creará una cuenta de depósito en la red Polygon vinculada a tu tarjeta`
};

const en_accounts_polygon_create_drawer_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `A deposit account on the Polygon network will be created and linked to your card`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const accounts_polygon_create_drawer_subtitle = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.accounts_polygon_create_drawer_subtitle(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("accounts_polygon_create_drawer_subtitle", locale)
	if (locale === "es") return es_accounts_polygon_create_drawer_subtitle(inputs)
	return en_accounts_polygon_create_drawer_subtitle(inputs)
};
export { accounts_polygon_create_drawer_subtitle as "accounts.polygon.create_drawer_subtitle" }